import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Modal, Form } from "react-bootstrap";
import ModalInputText from "./ModalInputText";
import { Store } from "react-notifications-component";
import PermissionContext from "../../../Store/permission-context";

const DebtPaymentModal = (props) => {
  const [ShowModal, setShowModal] = useState(props.showmodal);
  const PCtx = useContext(PermissionContext);

  let errorbackground = {
    backgroundColor: "#f04e00",
    fontFamily: "Times New Roman",
  };
  let successbackground = {
    backgroundColor: "#00ca65",
    fontFamily: "Times New Roman",
  };
  const [errorBackStyle, seterrorBackStyle] = useState(errorbackground);
  const [successBackStyle, setsuccessBackStyle] = useState(successbackground);
  const [NowPaying, setNowPaying] = useState(0);
  const [PaymentMode, setPaymentMode] = useState("Cash");

  const cancelM = () => {
    setShowModal(false);
    props.cancelModal();
  };

  const SaveThePayment = (e) => {
    e.preventDefault();
    let np = {
      ...props.debts,
      nowpaying: NowPaying,
      DebtCollector: PCtx.Username,
      PaymentMode: PaymentMode,
    };
    props.savedebtpayment(np);
    console.log(np);
  };

  const thisChange = () => {};

  const saveThePayment = () => {};

  const setnowpaying = (e) => {
    let val = e.target.value;
    if (!isNaN(val)) {
      setNowPaying(val);
    }
  };

  return (
    ShowModal && (
      <Modal
        show={ShowModal}
        onHide={cancelM}
        backdrop="static"
        keyboard={false}
        style={{ fontFamily: "Times New Roman", color: "brown" }}
      >
        <Modal.Header style={successBackStyle} closeButton>
          <Modal.Title style={{ color: "brown" }}>
            PAYMENT BY {props.debts.Customer}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            fontFamily: "Times New Roman",
          }}
        >
          <Form onSubmit={SaveThePayment}>
            <Row className="justify-content-around">
              <Col md={6} sm={6} xs={6}>
                <ModalInputText
                  Label="Customer's Name"
                  Name="CName"
                  Val={props.debts.Customer}
                  thischange={thisChange}
                  readonly={true}
                />
              </Col>
              <Col md={6} sm={6} xs={6}>
                <ModalInputText
                  Label="Amount Payable"
                  Name="CPayable"
                  Val={props.debts.Payable}
                  thischange={thisChange}
                  readonly={true}
                />
              </Col>
              <Col md={6} sm={6} xs={6}>
                <ModalInputText
                  Label="Amount Paid"
                  Name="CPaid"
                  Val={props.debts.Paid}
                  thischange={thisChange}
                  readonly={true}
                />
              </Col>
              <Col md={6} sm={6} xs={6}>
                <ModalInputText
                  Label="Balance"
                  Name="CBalance"
                  Val={props.debts.Balance}
                  thischange={thisChange}
                  readonly={true}
                />
              </Col>
            </Row>
            <hr />
            <Row className="justify-content-around">
              <Col md={6} sm={6} xs={6}>
                <ModalInputText
                  Label="Now Paying"
                  Name="CNpaying"
                  Val={NowPaying}
                  thischange={(e) => setnowpaying(e)}
                />
              </Col>
              <Col md={6}>
                <Form.Group controlId="Select">
                  <Form.Label>Payment Mode</Form.Label>
                  <Form.Control
                    as="select"
                    value={PaymentMode}
                    required="required"
                    onChange={(e) => {
                      setPaymentMode(e.target.value);
                    }}
                    name="Payment"
                    style={{ boxShadow: "5px 5px #b1b1b1" }}
                  >
                    <option value="Cash">Cash</option>
                    <option value="POS">POS</option>
                    <option value="Transfer">Transfer</option>
                    <option value="Credit">Credit</option>
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Row className="justify-content-around">
              <Col md={4} sm={4} xs={4}>
                <Button variant="outline-danger" onClick={cancelM}>
                  Cancel
                </Button>
              </Col>
              <Col md={4} sm={4} xs={4}>
                <Button variant="outline-success" type="submit">
                  Save
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    )
  );
};

export default DebtPaymentModal;
